/*
  Maison Ella — REVIEWS da PDP.
  Lê as reviews reais que a Okendo guarda no produto (dentro de um <template>
  inerte) e monta as fotos e o carrossel de reviews. Não chama APIs.
*/
(() => {
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const date = (iso) => {
    const d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const stars = (rating) => {
    const r = Math.max(0, Math.min(5, Number(rating) || 0));
    return `<span class="pdpb-stars" role="img" aria-label="Rated ${r} out of 5 stars"><span class="pdpb-stars__fill" style="width:${r * 20}%"></span></span>`;
  };

  // Okendo guarda miniaturas 120px; pede 400px quadrado ao mesmo serviço.
  const photoUrl = (m) => {
    const u = (m.imageUrls && (m.imageUrls.thumbnailUrl || m.imageUrls.largeUrl)) || '';
    return u.replace(/d=\d+x\d+/, 'd=400x400').replace(/(\?|&)crop=center/, '') + (u.includes('?') ? '&crop=center' : '?crop=center');
  };

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    const tpl = root.querySelector('template[data-pdpb-reviews-source]');
    const node = tpl && tpl.content.querySelector('script[data-oke-metafield-data]');
    let data = null;
    try {
      data = node ? JSON.parse(node.textContent) : null;
    } catch (e) {
      data = null;
    }
    const reviews = ((data && data.reviews) || []).filter((r) => r && r.status !== 'rejected');
    const media = ((data && data.media) || []).filter((m) => m && m.type === 'image' && m.imageUrls);

    // Fotos das clientes
    const mediaWrap = root.querySelector('[data-pdpb-media]');
    if (mediaWrap && media.length) {
      mediaWrap.querySelector('[data-rail-track]').innerHTML = media
        .map(
          (m) =>
            `<li class="pdpb-rail__item"><img src="${esc(photoUrl(m))}" alt="${esc(m.imageAlt || 'Customer photo')}" loading="lazy" width="400" height="400"></li>`
        )
        .join('');
      mediaWrap.hidden = false;
    }

    // Carrossel de reviews, uma de cada vez
    const car = root.querySelector('[data-pdpb-carousel]');
    if (car && reviews.length) {
      const track = car.querySelector('[data-carousel-track]');
      const dots = car.querySelector('[data-carousel-dots]');
      track.innerHTML = reviews
        .map((r, i) => {
          const name = (r.reviewer && r.reviewer.displayName) || '';
          const title = (r.title || '').trim();
          const body = (r.body || '').trim();
          return `<li class="pdpb-review" aria-roledescription="slide" aria-label="${i + 1} of ${reviews.length}">
            ${stars(r.rating)}
            ${title ? `<p class="pdpb-review__title">${esc(title)}</p>` : ''}
            ${body ? `<p class="pdpb-review__body">${esc(body)}</p>` : ''}
            <div class="pdpb-review__meta"><span>${name ? '&mdash; ' + esc(name) : ''}</span><span>${date(r.dateCreated)}</span></div>
          </li>`;
        })
        .join('');

      if (reviews.length > 1) {
        dots.innerHTML = reviews
          .map((_, i) => `<button type="button" role="tab" aria-label="Review ${i + 1}" aria-selected="${i === 0}" data-i="${i}"></button>`)
          .join('');
        dots.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-i]');
          if (b) track.scrollTo({ left: track.clientWidth * Number(b.dataset.i), behavior: 'smooth' });
        });
        track.addEventListener(
          'scroll',
          () => {
            const i = Math.round(track.scrollLeft / track.clientWidth);
            dots.querySelectorAll('button').forEach((b, j) => b.setAttribute('aria-selected', String(i === j)));
          },
          { passive: true }
        );
      }
      car.hidden = false;
    }

    if (window.pdpbRail) window.pdpbRail.update();

    // "View all reviews" abre o widget completo da Okendo (fechado por CSS)
    const btn = root.querySelector('[data-pdpb-view-all]');
    const full = document.querySelector('[data-oke-widget]');
    const fullSection = full && full.closest('.shopify-section');
    if (!btn) return;
    if (!fullSection) {
      btn.hidden = true;
    } else {
      btn.addEventListener('click', () => {
        const open = fullSection.classList.toggle('pdpb-oke-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.firstElementChild.textContent = open ? 'Hide all reviews' : 'View all reviews';
        if (open) fullSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // As estrelas junto ao título levavam ao widget da Okendo; agora trazem aqui.
    document.querySelectorAll('.product__wrapper .okeReviews.oke-sr').forEach((sr) => {
      sr.style.cursor = 'pointer';
      sr.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        true
      );
    });
  };

  const run = (scope) => (scope || document).querySelectorAll('[data-pdpb-reviews]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
